import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 支持的主题列表（与 panke-theme.css 里的 [data-theme] 对应）
export const THEMES = [
  { key: 'teal',    name: '青蓝',   desc: '医美清冷', swatch: ['#0891B2', '#0E7490'] },
  { key: 'indigo',  name: '靛蓝',   desc: '商务稳重', swatch: ['#4F6BED', '#3B53D4'] },
  { key: 'forest',  name: '墨绿',   desc: '沉稳自然', swatch: ['#3F8E6C', '#2E7050'] },
  { key: 'dark',    name: '暗夜',   desc: '护眼夜间', swatch: ['#1E1E26', '#22D3EE'] }
]

function applyTheme(theme) {
  if (typeof document !== 'undefined') {
    // 兼容老版本残留的 'rose' 主题（已下线）→ 回退到青蓝，避免首屏掉样式
    const valid = theme === 'rose' ? 'teal' : theme
    document.documentElement.setAttribute('data-theme', valid)
  }
}

// 启动时先把已保存的主题应用到 <html>，避免首屏闪烁
const savedTheme = localStorage.getItem('theme') || 'teal'
applyTheme(savedTheme)

// 安全解析 localStorage 里的 userInfo：被篡改/损坏时回退为空对象，避免拖垮启动
function safeParseUser() {
  try {
    const raw = localStorage.getItem('userInfo') || '{}'
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    return {}
  }
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: safeParseUser(),
    theme: savedTheme
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) localStorage.setItem('token', token)
      else localStorage.removeItem('token')
    },
    SET_USER(state, user) {
      state.userInfo = user || {}
      if (user) localStorage.setItem('userInfo', JSON.stringify(user))
      else localStorage.removeItem('userInfo')
    },
    SET_THEME(state, theme) {
      state.theme = theme
      localStorage.setItem('theme', theme)
      applyTheme(theme)
    }
  },
  getters: {
    isLogin: state => !!state.token,
    role: state => state.userInfo.role,
    isAdmin: state => state.userInfo.role === 'ADMIN',
    isSupervisor: state => state.userInfo.role === 'SUPERVISOR',
    isConsultant: state => state.userInfo.role === 'CONSULTANT',
    isEmployee: state => state.userInfo.role === 'EMPLOYEE',
    // ===== 功能权限三开关（84号SQL，登录返回；ADMIN 恒 true；老登录态无字段时按角色回退） =====
    permPanke: state => {
      const u = state.userInfo
      if (u.role === 'ADMIN') return true
      if (typeof u.permPanke === 'boolean') return u.permPanke
      return ['ADMIN', 'SUPERVISOR', 'CONSULTANT'].includes(u.role)   // 旧会话兼容
    },
    permMedicalOrder: state => {
      const u = state.userInfo
      if (u.role === 'ADMIN') return true
      if (typeof u.permMedicalOrder === 'boolean') return u.permMedicalOrder
      return ['ADMIN', 'SUPERVISOR', 'CONSULTANT'].includes(u.role)
    },
    permPoster: state => {
      const u = state.userInfo
      if (u.role === 'ADMIN') return true
      if (typeof u.permPoster === 'boolean') return u.permPoster
      return true   // 营销默认全员开放
    },
    // 回访记录权限（90号SQL）：2026-10-27 用户令——本功能只开放给管理权限人员（ADMIN/回访管理开关），
    // perm_visit_record 字段停用不再作入口依据
    permVisitRecord: state => {
      const u = state.userInfo
      if (u.role === 'ADMIN') return true
      return u.permVisitManage === true
    },
    permVisitManage: state => {
      const u = state.userInfo
      if (u.role === 'ADMIN') return true
      if (typeof u.permVisitManage === 'boolean') return u.permVisitManage
      return false
    },
    // 年度规划权限（91号SQL，2026-10-28）：默认全员关，逐个分配
    permAnnualPlan: state => {
      const u = state.userInfo
      if (u.role === 'ADMIN') return true
      return u.permAnnualPlan === true
    },
    // 盘客系统准入（工具选择页/路由守卫）：改为按权限开关（管理员在用户管理里可关）
    pankeAccess: (state, getters) => getters.permPanke,
    // 门店维度（多门店改造）
    storeId: state => state.userInfo.storeId || null,
    storeName: state => state.userInfo.storeName || '',
    hasStoreScope: state => state.userInfo.storeId != null   // false=管理员(全门店)
  }
})
